import React from "react";
import PropTypes from "prop-types";

const SquareTicked = ({ className, color }) => {
  return (
    <svg className={className} viewBox="0 0 15.5 15.5">
      <g>
        <polyline
          fill="none"
          stroke={color}
          strokeWidth={0.5}
          points="2.25 7.75 5.92 11.42 13.25 4.08"
        />
        <rect
          fill="none"
          stroke={color}
          strokeWidth={0.5}
          x="0.25"
          y="0.25"
          width="15"
          height="15"
        />
      </g>
    </svg>
  );
};

SquareTicked.defaultProps = {
  className: ``,
  color: `#231f20`
};

SquareTicked.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default SquareTicked;
